export const BUSINESS_CONFIG = {
    /**
     * Chế độ in quyết định hàng loạt (đều gọi API `Print/Decisions`)
     *  - `server`          : chỉ gửi mã hồ sơ — backend tự lấy Values
     *  - `server_ui_values`: UI tự map Values + TableJsonValues rồi gửi kèm
     * @type {'server' | 'server_ui_values'}
     */
    print_decision_many_mode: 'server_ui_values' as
        | 'server'
        | 'server_ui_values',
    /**
     * Nguồn nhóm đối tượng "Sinh viên" trong cây loại thủ tục
     *  - `procedure_type`: khai trực tiếp ở màn hình loại thủ tục (như cũ)
     *  - `uis`           : lấy danh sách loại hình đào tạo từ `UIS_LoaiHinhDaoTao`,
     *                      mỗi loại hình = 1 node `student_<StudyTypeID>`; các node
     *                      `student*` khai trong DB bị ẩn. Sinh viên khớp node khi
     *                      `StudentInfo.StudyTypeID` trùng `<StudyTypeID>` (thiếu
     *                      StudyTypeID ⇒ chỉ thấy thủ tục dùng chung).
     *                      Cán bộ / vãng lai vẫn lấy từ loại thủ tục như cũ.
     * @type {'procedure_type' | 'uis'}
     */
    student_procedure_type_source: 'procedure_type' as 'procedure_type' | 'uis',
};
